import { render, staticRenderFns } from "./veJkyProjectWork.vue?vue&type=template&id=6f792796&scoped=true"
import script from "./veJkyProjectWork.vue?vue&type=script&lang=js"
export * from "./veJkyProjectWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f792796",
  null
  
)

export default component.exports